module.exports = __webpack_public_path__ + "static/img/img-features-feature-3-list-cn-m.96eb5e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-3-list-cn-m.png
// module id = N9G/
// module chunks = 18